"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * @author yuqzho@microsoft.com, KennethBWSong, SLdragon, Ning Tang
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.kiotaPostProcess = exports.getAuthDataFromKiota = exports.isKiotaIntegrated = void 0;
const tslib_1 = require("tslib");
const fs_extra_1 = tslib_1.__importDefault(require("fs-extra"));
const neverthrow_1 = require("neverthrow");
const path_1 = tslib_1.__importDefault(require("path"));
const featureFlags_1 = require("../../../common/featureFlags");
const question_1 = require("../../../question");
const CopilotGptManifestUtils_1 = require("../../driver/teamsApp/utils/CopilotGptManifestUtils");
const const_1 = require("./const");
const helper_1 = require("./helper");
function isKiotaIntegrated(inputs) {
    return (featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.KiotaIntegration) &&
        inputs[question_1.QuestionNames.ActionManifestPath]);
}
exports.isKiotaIntegrated = isKiotaIntegrated;
async function getAuthDataFromKiota(context, inputs) {
    // For Kiota integration, we need to get auth info here
    if (isKiotaIntegrated(inputs)) {
        const pluginManifestPath = inputs[question_1.QuestionNames.ActionManifestPath];
        return await (0, helper_1.parseAndUpdatePluginManifestForKiota)(pluginManifestPath, false);
    }
    return undefined;
}
exports.getAuthDataFromKiota = getAuthDataFromKiota;
async function kiotaPostProcess(context, inputs, destinationPath, openapiSpecPath, pluginManifestPath, manifestPath, templateType, isDeclarativeAgent) {
    // For Kiota integration scenario, we need to:
    // 1. Copy openapi spec file
    await fs_extra_1.default.copyFile(inputs[question_1.QuestionNames.ApiSpecLocation].trim(), openapiSpecPath);
    // 2. Copy plugin manifest file
    await fs_extra_1.default.copyFile(inputs[question_1.QuestionNames.ActionManifestPath], pluginManifestPath);
    // 2.1 Need to update the plugin manifest file
    await (0, helper_1.parseAndUpdatePluginManifestForKiota)(pluginManifestPath, true);
    // 3. Update teams app manifest
    const manifest = await fs_extra_1.default.readJSON(manifestPath);
    const apiPluginRelativePath = path_1.default.relative(manifestPath, pluginManifestPath);
    manifest.copilotAgents = manifest.copilotAgents || {};
    manifest.copilotAgents.plugins = [
        {
            file: apiPluginRelativePath,
            id: "plugin_1",
        },
    ];
    // 4. add action in da manifest
    const addActionResult = await CopilotGptManifestUtils_1.copilotGptManifestUtils.updateDeclarativeAgentManifest(manifestPath, const_1.defaultDeclarativeAgentManifestFileName, const_1.defaultDeclarativeAgentActionId, pluginManifestPath);
    if (addActionResult.isErr()) {
        return (0, neverthrow_1.err)(addActionResult.error);
    }
    // 5. Update plugin manifest to add ac info (optional)
    await (0, helper_1.generateAdaptiveCardInPluginManifestForKiota)(pluginManifestPath, openapiSpecPath, context);
    // 5. Copy .kiota folder
    await (0, helper_1.copyKiotaFolder)(inputs[question_1.QuestionNames.ActionManifestPath], destinationPath);
    return (0, neverthrow_1.ok)({ warnings: undefined });
}
exports.kiotaPostProcess = kiotaPostProcess;
//# sourceMappingURL=kiota.js.map